module.exports = __webpack_public_path__ + "img/SKODA.5f2e677.jpg";